import React, { useState, useEffect } from 'react';
import axios from '../../api/axios';
import useAuth from '../../hooks/useAuth';
import notFound from '../../assets/empty.png';

const WEBSITE_URL = '/image_url';

export default function FetchImage(props) {
    const { username } = useAuth();
    const [currentImageURL, setCurrentImageURL] = useState(null);

    // load on render
    useEffect(() => {
        const title = props.title
        const getContent = async () => {
            try {
                const response = await axios.get(`${WEBSITE_URL}`, {
                    params: { username, title },
                }).catch((err) => {
                    if (err.response.status === 404) {
                        setCurrentImageURL(notFound);
                    }
                }
                );
                if (response.data) {
                    setCurrentImageURL(response.data);
                }
            } catch (err) {
                console.error(err);
            }
        };
        getContent();
    }, [props.title, username]);

    return (
        <div className='image-content'>
            <div className={props.type}>
                {currentImageURL && (
                    <img className={props.type} src={currentImageURL} alt="" onLoad={props.onImageLoad} />
                )}
            </div>
        </div>
    );
}
